import { render } from "./downloadList.vue?vue&type=template&id=54fdbd14&bindings={\"documentList\":\"props\"}"
import script from "./downloadList.vue?vue&type=script&lang=js"
export * from "./downloadList.vue?vue&type=script&lang=js"
script.render = render

export default script